export default __webpack_public_path__ + "static/018-fb3955c8f6e1baab4436df2ca40c055e.jpg";